import API from './settings'

export const filterElements = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/element/filter`, formData);
};

export const getElement = (project_code: string, element_id: string): any => {
    return API.get(`${project_code}/element/get/${element_id}`);
};

export const createElement = (project_code: string, formData: any): any => {
    return API.post(`${project_code}/element/create`, formData);
};

export const editElement = (project_code: string, element_code: string, formData: any): any => {
    return API.post(`${project_code}/element/edit/${element_code}`, formData);
};

export const removeElement = (project_code: string, element_code: string): any => {
    return API.post(`${project_code}/element/delete/${element_code}`);
};

export const getElementChildren = (element_id: string): any => {
    return API.get(`/element/links/children/${element_id}`);
};

export const getElementParents = (element_id: string): any => {
    return API.get(`/element/links/parents/${element_id}`);
};

export const getChildCandidates = (element_id: string): any => {
    return API.get(`/element/get_child_candidates/${element_id}`);
};

export const getParentCandidates = (element_id: string): any => {
    return API.get(`/element/get_parent_candidates/${element_id}`);
};

export const addElementChildren = (element_id: string, formData: any): any => {
    //return API.post(`/element/children/add/${element_id}`, formData);
    return []
};

export const addElementParents = (element_id: string, formData: any): any => {
    //return API.post(`/element/parents/add/${element_id}`, formData);
    return []
};

export const getElementSite = (project_code: string, element_id: string): any => {
    return API.get(`${project_code}/element/site/get/${element_id}`);
};
